<div class="container">
  <div class="header">
    <pdq-heading element="h3"
      >{{
        mode === ACTIONS.CREATE || mode === ACTIONS.DUPLICATE
          ? 'Create'
          : mode === ACTIONS.EDIT_RUNNING_ABTEST
            ? 'Edit running'
            : 'View'
      }}
      A/B Test</pdq-heading
    >
    <pdq-button
      [disabled]="isLoading$ | async"
      (onClick)="dialogRef.close()"
      iconColor="var(--on-surface-light)"
      variant="ghost"
      icon="close"></pdq-button>
  </div>
  <div class="wrapper">
    <pdq-tabs-group variant="underline" (onChange)="onTabChange($event)">
      <pdq-tab label="Control A" [value]="VARIANT.CONTROL" [active]="mode === ACTIONS.EDIT_RUNNING_ABTEST"></pdq-tab>
      <pdq-tab
        label="Test B"
        [value]="VARIANT.TEST"
        [active]="mode === ACTIONS.CREATE || mode === ACTIONS.EDIT || mode === ACTIONS.DUPLICATE"></pdq-tab>
    </pdq-tabs-group>

    <div class="content">
      <div class="section-wrapper" [ngStyle]="{ display: 'flex', 'justify-content': 'space-between' }">
        <div [ngStyle]="{ display: 'flex', 'flex-direction': 'column' }">
          <span class="label">Use B variant as a test group</span>
          <span class="label__secondary">Don't present this delivery method and keep checkout as is</span>
        </div>
        <form [formGroup]="formGroup">
          <pdq-slide-toggle
            formControlName="hideVariantB"
            (onToggle)="onHideVariantBToggle($event)"
            [disabled]="currentTab === VARIANT.CONTROL || mode === ACTIONS.EDIT"></pdq-slide-toggle>
        </form>
      </div>
      <div
        class="section-wrapper"
        *ngIf="(settings$ | async)?.enableOptimization && currentTab !== VARIANT.CONTROL"
        [ngStyle]="{ display: 'flex', 'justify-content': 'space-between' }">
        <div [ngStyle]="{ display: 'flex', 'flex-direction': 'column' }">
          <span class="label">Rates Optimization</span>
          <span class="label__secondary">Disable rates optimization on this delivery method</span>
        </div>
        <form [formGroup]="formGroup">
          <pdq-slide-toggle
            formControlName="disableRatesOptimization"
            [disabled]="mode === ACTIONS.EDIT"></pdq-slide-toggle>
        </form>
      </div>
      <ng-container
        *ngTemplateOutlet="
          loadLiveRateForm ? domesticLiveRateForm : domesticOrLocalForm;
          context: {
            disableField:
              (currentTab === VARIANT.CONTROL || mode === ACTIONS.EDIT) && mode !== ACTIONS.EDIT_RUNNING_ABTEST,
            isOriginalVariant: currentTab === VARIANT.CONTROL,
            isViewMode: mode === ACTIONS.EDIT,
          }
        "></ng-container>
    </div>
  </div>
  <footer>
    <ng-container *ngIf="mode == ACTIONS.EDIT_RUNNING_ABTEST">
      <pdq-button [disabled]="isABTestLoading$ | async" label="Cancel" (onClick)="dialogRef.close()"></pdq-button>
      <pdq-button
        (onClick)="onEditRunningABTest()"
        [loading]="isABTestLoading$ | async"
        variant="primary"
        [label]="'Save and restart test'"
        [disabled]="formGroup.invalid || (isABTestLoading$ | async)"></pdq-button>
    </ng-container>
    <ng-container *ngIf="mode !== ACTIONS.EDIT && !isPreviewOnly && mode != ACTIONS.EDIT_RUNNING_ABTEST">
      <pdq-button [disabled]="isLoading$ | async" label="Cancel" (onClick)="dialogRef.close()"></pdq-button>
      <pdq-button
        (onClick)="onSave()"
        [loading]="isLoading$ | async"
        variant="primary"
        [label]="'Start test'"
        [disabled]="currentTab === VARIANT.CONTROL || formGroup.invalid || (isABTestLoading$ | async)"></pdq-button>
    </ng-container>
    <ng-container *ngIf="mode === ACTIONS.EDIT && !isPreviewOnly">
      <pdq-button [disabled]="isLoading$ | async" label="Cancel" (onClick)="dialogRef.close()"></pdq-button>
      <pdq-button
        (onClick)="onSave()"
        [loading]="isLoading$ | async"
        variant="primary"
        [label]="'Save'"
        [disabled]="currentTab === VARIANT.CONTROL || formGroup.invalid || (isABTestLoading$ | async)"></pdq-button>
    </ng-container>
  </footer>
</div>

<ng-template
  #domesticOrLocalForm
  let-disableField="disableField"
  let-isOriginalVariant="isOriginalVariant"
  let-isViewMode="isViewMode">
  <form [formGroup]="formGroup">
    <span class="errors" *ngIf="formGroup?.errors?.no_values_changed">{{ formGroup?.errors.no_values_changed }}</span>
    <div class="section-wrapper" fxLayout="column">
      <div class="flex gap-16">
        <pdq-input
          class="width-100"
          label="Custom name"
          formControlName="name"
          placeholder="Leave blank to show the live rate’s name"
          [disabled]="disableField"></pdq-input>
        <pdq-input
          class="width-100"
          label="Description"
          formControlName="notes"
          placeholder="Example: Arrives the following business day"
          [disabled]="disableField"></pdq-input>
      </div>
      <div class="flex width-100 gap-16" style="align-items: flex-end">
        <pdq-input-arrows
          width="290"
          widthSize="auto"
          label="Shipping rate per delivery"
          precision="2"
          min="0"
          [formControl]="formGroup.controls['rate']"
          [symbol]="currencySymbol"
          [disabled]="disableField"></pdq-input-arrows>
        <pdq-input-arrows
          widthSize="auto"
          label="Min cart value"
          precision="2"
          min="0"
          [formControl]="formGroup.controls['minOrderPriceRange']"
          [symbol]="currencySymbol"
          [disabled]="disableField"></pdq-input-arrows>
        <pdq-input-arrows
          widthSize="auto"
          label="Max cart value"
          min="0"
          precision="2"
          placeholder="No limit"
          [required]="false"
          [formControl]="formGroup.controls['maxOrderPriceRange']"
          [symbol]="currencySymbol"
          [disabled]="disableField"></pdq-input-arrows>
      </div>

      <ng-container formArrayName="additionalPriceRanges">
        <div
          class="flex width-100 gap-16"
          style="align-items: flex-end"
          *ngFor="let priceRange of additionalPriceRangeFormArray.controls; let i = index">
          <ng-container [formGroupName]="i">
            <pdq-input-arrows
              width="290"
              widthSize="auto"
              label="Shipping rate per delivery"
              formControlName="rate"
              min="0"
              precision="2"
              [symbol]="currencySymbol"
              [disabled]="disableField"></pdq-input-arrows>
            <pdq-input-arrows
              widthSize="auto"
              label="Min cart value"
              formControlName="minOrderPriceRange"
              min="0"
              precision="2"
              [symbol]="currencySymbol"
              [disabled]="disableField"></pdq-input-arrows>
            <pdq-input-arrows
              widthSize="auto"
              label="Max cart value"
              formControlName="maxOrderPriceRange"
              precision="2"
              min="0"
              placeholder="No limit"
              [required]="false"
              [symbol]="currencySymbol"
              [disabled]="disableField"></pdq-input-arrows>

            <pdq-button
              (onClick)="removePriceRangeAt(i)"
              iconColor="var(--on-surface-light)"
              variant="ghost"
              icon="close"
              [disabled]="disableField"></pdq-button>
          </ng-container>
        </div>
      </ng-container>

      <pdq-button variant="light" [disabled]="disableField" (onClick)="addPriceRange($event)"
        >+Add another rate</pdq-button
      >
    </div>

    <ng-container *ngIf="!isOriginalVariant">
      <div class="section-wrapper">
        <div class="flex width-100 gap-16">
          <pdq-input-arrows
            *ngIf="!(settings$ | async)?.runTestVariantsTogether; else globalPercentTraffic"
            width="290"
            widthSize="auto"
            min="0"
            label="Percent of traffic to send to new variant"
            [disabled]="isViewMode"
            [formControl]="formGroup.controls['percentTestVariantTraffic']"
            symbol="%"></pdq-input-arrows>
          <ng-template #globalPercentTraffic>
            <div>
              <pdq-input-arrows
                width="290"
                widthSize="auto"
                min="0"
                label="Percent of traffic to send to new variant"
                [disabled]="true"
                [value]="(settings$ | async).percentTestVariantTraffic"
                symbol="%"></pdq-input-arrows>
              <span class="flex label inherited-setting"
                >Inherited from <pdq-link (onClick)="navigateToCheckoutSettings()" label="global settings"></pdq-link
              ></span>
            </div>
          </ng-template>
          <pdq-input-arrows
            width="290"
            widthSize="auto"
            label="Number of checkouts visits to complete test"
            placeholder="No limit"
            [required]="false"
            [min]="0"
            [disabled]="isViewMode"
            [formControl]="formGroup.controls['appearanceLimit']"></pdq-input-arrows>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!isOriginalVariant">
      <div class="section-wrapper">
        <div class="width-100 gap-16" [ngStyle]="{ display: 'flex', 'flex-direction': 'column' }">
          <choose-abtest-group
            (onABTestGroupSelected)="onABTestGroupSelected($event)"
            [prepopulatedGroupId]="testVariant?.testVariantFields?.abtestGroupId"
            [disabled]="isViewMode"></choose-abtest-group>
        </div>
      </div>
    </ng-container>

    <div class="section-wrapper" fxLayout="column">
      <span class="errors" *ngIf="formGroup.errors?.delivery_promise_missmatch">
        {{ formGroup.errors?.delivery_promise_missmatch }}</span
      >
      <ng-container *ngIf="category != ShippingMethod.LOCAL">
        <div class="label">
          Show estimated delivery time in checkout
          <pdq-slide-toggle
            formControlName="displayEstimatedDeliveryBusinessDays"
            [disabled]="disableField || !!formGroup?.value?.displayEstDelivery"></pdq-slide-toggle>
        </div>
        <div class="label__secondary">(“2 to 5 business days”)</div>
      </ng-container>
      <div class="label">
        Show delivery date range
        <pdq-slide-toggle
          formControlName="displayEstDelivery"
          [disabled]="disableField || !!formGroup?.value?.displayEstimatedDeliveryBusinessDays"></pdq-slide-toggle>
      </div>
      <div class="label__secondary">("Estimated delivery between Tuesday Aug 14 to Thursday Aug 16, 2021")</div>

      <ng-container *ngIf="!!formGroup?.value?.displayEstDelivery">
        <pdq-input
          formControlName="deliveryPromiseArrivalSingleDateDisplayText"
          label="Display text for single arrival date"
          [invalid]="formGroup?.controls?.deliveryPromiseArrivalSingleDateDisplayText?.hasError('dp_date_text')"
          [invalidMsg]="formGroup?.controls?.deliveryPromiseArrivalSingleDateDisplayText?.getError('dp_date_text')"
          [disabled]="disableField"></pdq-input>

        <pdq-input
          formControlName="deliveryPromiseArrivalDateRangeDisplayText"
          label="Display text for date range"
          [invalid]="formGroup?.controls?.deliveryPromiseArrivalDateRangeDisplayText?.hasError('dp_date_text')"
          [invalidMsg]="formGroup?.controls?.deliveryPromiseArrivalDateRangeDisplayText?.getError('dp_date_text')"
          [disabled]="disableField"></pdq-input>
      </ng-container>

      <div class="flex gap-16">
        <pdq-input-arrows
          width="290"
          widthSize="auto"
          label="Min delivery {{ category === 'local' ? 'hour(s)' : 'day(s)' }}"
          min="0"
          [formControl]="formGroup.controls['deliveryPromiseMin']"
          [disabled]="disableField"></pdq-input-arrows>
        <pdq-input-arrows
          width="290"
          widthSize="auto"
          label="Max delivery {{ category === 'local' ? 'hour(s)' : 'day(s)' }}"
          min="0"
          [formControl]="formGroup.controls['deliveryPromiseMax']"
          [disabled]="disableField"></pdq-input-arrows>
      </div>
    </div>
  </form>
</ng-template>

<ng-template
  #domesticLiveRateForm
  let-disableField="disableField"
  let-isOriginalVariant="isOriginalVariant"
  let-isViewMode="isViewMode">
  <form [formGroup]="formGroup">
    <span class="errors" *ngIf="formGroup.errors?.delivery_promise_missmatch">
      {{ formGroup.errors?.delivery_promise_missmatch }}</span
    >
    <span *ngIf="formGroup.errors?.no_values_changed">{{ formGroup.errors.no_values_changed }}</span>
    <div class="section-wrapper" fxLayout="column">
      <div class="flex gap-16">
        <pdq-input
          class="width-100"
          label="Custom name"
          formControlName="name"
          placeholder="Leave blank to show the live rate’s name"
          [disabled]="disableField"></pdq-input>
        <pdq-input
          class="width-100"
          label="Description"
          formControlName="notes"
          placeholder="Example: Arrives the following business day"
          [disabled]="disableField"></pdq-input>
      </div>
      <div class="flex width-100 gap-16" style="align-items: flex-end">
        <pdq-input-arrows
          width="290"
          widthSize="auto"
          label="Percentage of shipping rate to charge"
          [formControl]="formGroup.controls['percentageOfCarrierCost']"
          symbol="%"
          [min]="-100"
          [max]="300"
          [disabled]="disableField"></pdq-input-arrows>
        <pdq-input-arrows
          width="290"
          widthSize="auto"
          label="Additional flat fee"
          min="0"
          precision="2"
          [formControl]="formGroup.controls['flatAmount']"
          [symbol]="currencySymbol"
          [disabled]="disableField"></pdq-input-arrows>
      </div>

      <div class="gap-16" fxLayout="column">
        <pdq-checkbox
          label="Calculate rate in checkout by order’s specific package size"
          formControlName="calculatePackageDimension"
          [disabled]="disableField"></pdq-checkbox>

        <pdq-radio-group formControlName="rateConversion" [disabled]="disableField">
          <pdq-radio-button
            *ngFor="let customRates of displayRatesAsConfig"
            [value]="customRates.value"
            [checked]="customRates.checked(formGroup.value['rateConversion']) || customRates.defaultChecked"
            [text]="customRates.text"
            [subText]="customRates.subText">
          </pdq-radio-button>
        </pdq-radio-group>
      </div>
    </div>

    <ng-container *ngIf="!isOriginalVariant">
      <div class="section-wrapper" fxLayout="column">
        <div class="flex width-100 gap-16">
          <pdq-input-arrows
            *ngIf="!(settings$ | async)?.runTestVariantsTogether; else globalPercentTraffic"
            width="290"
            widthSize="auto"
            min="0"
            label="Percent of traffic to send to new variant"
            [disabled]="isViewMode"
            [formControl]="formGroup.controls['percentTestVariantTraffic']"
            symbol="%"></pdq-input-arrows>
          <ng-template #globalPercentTraffic>
            <div>
              <pdq-input-arrows
                width="290"
                widthSize="auto"
                min="0"
                label="Percent of traffic to send to new variant"
                [disabled]="true"
                [value]="(settings$ | async).percentTestVariantTraffic"
                symbol="%"></pdq-input-arrows>
              <span class="flex label inherited-setting"
                >Inherited from <pdq-link (onClick)="navigateToCheckoutSettings()" label="global settings"></pdq-link
              ></span>
            </div>
          </ng-template>
          <pdq-input-arrows
            width="290"
            widthSize="auto"
            [min]="0"
            label="Number of checkouts visits to complete test"
            placeholder="No limit"
            [required]="false"
            [disabled]="isViewMode"
            [formControl]="formGroup.controls['appearanceLimit']"></pdq-input-arrows>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!isOriginalVariant">
      <div class="section-wrapper">
        <div class="width-100 gap-16" [ngStyle]="{ display: 'flex', 'flex-direction': 'column' }">
          <choose-abtest-group
            (onABTestGroupSelected)="onABTestGroupSelected($event)"
            [prepopulatedGroupId]="testVariant?.testVariantFields?.abtestGroupId"
            [disabled]="isViewMode"></choose-abtest-group>
        </div>
      </div>
    </ng-container>

    <div class="section-wrapper" fxLayout="column">
      <span class="errors" *ngIf="formGroup.errors?.delivery_promise_missmatch">
        {{ formGroup.errors?.delivery_promise_missmatch }}</span
      >

      <ng-container *ngIf="category != ShippingMethod.LOCAL">
        <div class="label">
          Show estimated delivery time in checkout
          <pdq-slide-toggle
            formControlName="displayEstimatedDeliveryBusinessDays"
            [disabled]="disableField"></pdq-slide-toggle>
        </div>
        <div class="label__secondary">(“2 to 5 business days”)</div>
      </ng-container>

      <div class="label">
        Show estimated delivery date range in checkout
        <pdq-slide-toggle formControlName="displayEstDelivery" [disabled]="disableField"></pdq-slide-toggle>
      </div>
      <div class="label__secondary">("Estimated delivery between Tuesday Aug 14 to Thursday Aug 16, 2021")</div>

      <ng-container *ngIf="!!formGroup?.value?.displayEstDelivery">
        <pdq-input
          formControlName="deliveryPromiseArrivalSingleDateDisplayText"
          label="Display text for single arrival date"
          [invalid]="formGroup?.controls?.deliveryPromiseArrivalSingleDateDisplayText?.hasError('dp_date_text')"
          [invalidMsg]="formGroup?.controls?.deliveryPromiseArrivalSingleDateDisplayText?.getError('dp_date_text')"
          [disabled]="disableField"></pdq-input>

        <pdq-input
          formControlName="deliveryPromiseArrivalDateRangeDisplayText"
          label="Display text for date range"
          [invalid]="formGroup?.controls?.deliveryPromiseArrivalDateRangeDisplayText?.hasError('dp_date_text')"
          [invalidMsg]="formGroup?.controls?.deliveryPromiseArrivalDateRangeDisplayText?.getError('dp_date_text')"
          [disabled]="disableField"></pdq-input>
      </ng-container>

      <div class="flex gap-16">
        <pdq-input-arrows
          width="290"
          widthSize="auto"
          min="0"
          label="Min delivery {{ category === 'local' ? 'hour(s)' : 'day(s)' }}"
          [formControl]="formGroup.controls['deliveryPromiseMin']"
          [disabled]="disableField"></pdq-input-arrows>
        <pdq-input-arrows
          width="290"
          widthSize="auto"
          min="0"
          label="Max delivery {{ category === 'local' ? 'hour(s)' : 'day(s)' }}"
          [formControl]="formGroup.controls['deliveryPromiseMax']"
          [disabled]="disableField"></pdq-input-arrows>
      </div>
    </div>
  </form>
</ng-template>
